import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { DwAuthService } from '../../../auth/auth.service';


@Injectable()
export class DwMenuLangLoaderService {

  constructor(
    private http: HttpClient,
    private authService: DwAuthService
  ) { }

  /**
   * 選單翻譯檔載入器
   * @param lang 語系
   */
  getTranslation(lang: string): Observable<any> {
    const isLoggedIn = this.authService.isLoggedIn; // 是否已登入
    const subject: Subject<any> = new Subject<any>();

    subject.complete();

    return subject.asObservable();
  }
}
